import axios from "axios";

const CMS_BASE_URL = "https://cms-stage.curebay.in/api/";

export function getCaresathiData() {
  return axios.get(`${CMS_BASE_URL}caresathi-news?populate=first,first.buttons,second,third,third.thirdsub,fourth,fourth.fourthsub,lifechanges,lifechanges.beforepoints,lifechanges.afterpoints,seventh,seventh.seventhsub,seventh.seventhsub.points,stats,stats.sub,subscribe,sixth,sixth.sixthsub,eighth,eight,eight.subheading,eight.subheading.subcomp`);
}
